import React from 'react'
import './Project.css'
import { Fade } from 'react-reveal'
import Section from '../section/Section'
import ProjectCard from '../projectCard/ProjectCard'
import projectData from '../../data/project.json'

const Project = () => {
  return (
    <Section title="Projects">
      <div className="project-content">
        <ul className="project-list">
          {projectData.project.reverse().map((exp) => (
            <li key={`project-${exp.company}`}>
              <Fade bottom duration={1000} distance="20px">
                <ProjectCard project={exp} />
              </Fade>
            </li>
          ))}
        </ul>
        <Fade bottom duration={1200} distance="20px">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <p style={{ textAlign: 'center', marginTop: '70px' }}>
              More Interesting Projects and Codes can be found on my{' '}
              <a
                href="https://github.com/vipinmenon006"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: '#0be779',
                  cursor: 'pointer',
                }}
              >
                GitHub
              </a>
              .
            </p>
          </div>
        </Fade>
      </div>
    </Section>
  )
}

export default Project
